import type { Messages } from "@prop/i18n";
import type en from "../en/wallet";

export default {
  nav: "Saldo",
  chip: "Saldo: {amount}",
  page: {
    title: "Saldo",
    lead: "Recarga con cripto y paga challenges, reinicios y activaciones con un toque.",
    available: "Disponible",
    topupTitle: "Recargar",
    amount: "Monto, USD",
    amountHint: "De {min} a {max}",
    start: "Recargar {amount}",
    noCrypto: "Las recargas no están disponibles en este momento. Escribe a soporte.",
    history: "Historial",
    empty: "Aún no hay nada. Recarga para pagar un challenge con el saldo.",
    continue: "Continuar la compra",
    credited: "Se acreditaron {amount}. El saldo ya se puede usar.",
    open: "Esperando el pago",
    another: "Nueva recarga",
    pay: "Pagar",
    money: "Dinero",
    moneyHint: "Lo que depositaste o te devolvieron. Se puede retirar.",
    bonus: "Bono",
    bonusHint: "Un regalo del equipo: paga challenges y comisiones, no se puede retirar. Se usa después de tu dinero.",
    bonusBurns: "{amount} vence {at}",
    frozen: "Tu saldo está congelado: tu verificación de identidad muestra un país al que no podemos dar servicio. Escribe a soporte.",
  },
  moves: {
    topup: "Recarga",
    purchase: "Compra",
    refund: "Reembolso",
    adjustment: "Corrección del equipo",
    overpay: "Pago en exceso de un pedido",
    bonus: "Bono del equipo",
    bonus_expired: "Bono vencido",
    withdrawal: "Retiro",
    withdrawal_released: "Retiro devuelto",
  },
  status: { awaiting_payment: "esperando el pago", paid: "acreditada", expired: "plazo cerrado", manual_review: "en revisión", canceled: "cancelada" },
  pay: {
    method: "Saldo",
    fromBalance: "Pagar con el saldo",
    have: "En el saldo {amount}",
    short: "Faltan {short}",
    topupAndPay: "Recargar {amount} y pagar",
    feeTitle: "Pagar {amount}",
    feeLead: "Paga con tu saldo en un toque o envía cripto: la acción se ejecuta sola en cuanto llega el pago.",
    feeFromBalance: "Pagar {amount} con el saldo",
    feeCrypto: "Pagar con cripto",
    feeTopup: "Recargar el saldo",
    feeWaiting: "Esperando el pago: la página se actualiza sola.",
    feeDone: "Pagado. Listo.",
    feeKept: "El pago llegó, pero la acción ya no se pudo ejecutar. El dinero está en tu saldo.",
    feeStart: "Mostrar la dirección",
  },
  withdraw: {
    title: "Retirar",
    lead: "El dinero de tu saldo va a una de tus billeteras de payout. El equipo revisa cada solicitud y la envía manualmente.",
    amount: "Monto, USD",
    min: "Desde {min}, hasta {max}",
    to: "Enviar a",
    fee: "Tarifa de red",
    net: "Recibes",
    confirm: "Retirar {amount}",
    sent: "Solicitado. El monto queda retenido en tu saldo hasta que el equipo lo envíe.",
    needKyc: "Los retiros requieren una verificación de identidad aprobada.",
    goKyc: "Verificar identidad",
    needWallet: "Primero agrega una billetera de payout. Una dirección nueva se puede usar cuando termina su plazo de espera.",
    goWallet: "Billeteras de payout",
    belowMin: "El retiro mínimo es {min}. Tu dinero: {money}.",
    restricted: "Los retiros no están disponibles para tu país de residencia. Escribe a soporte.",
    history: "Retiros",
    status: { requested: "en espera", prepared: "en revisión", paid: "enviado", rejected: "rechazado" },
    refund: "Reembolso a tu billetera",
  },
  errors: {
    insufficient_balance: "No hay suficiente saldo.",
    topups_open: "Ya tienes tres recargas abiertas. Paga una de ellas o espera a que se cierre su plazo.",
    topup_amount: "Una recarga va de {min} a {max}.",
    rail_busy: "Esta red está ocupada en este momento. Elige otra moneda.",
    pay_from_balance: "Tu saldo alcanza: paga con el saldo.",
    payments_not_live: "Las recargas no están disponibles en este momento.",
    withdrawal_min: "Un retiro es de al menos {min}.",
    withdrawal_open: "Ya tienes un retiro en espera. Espera a que el equipo lo resuelva.",
    kyc: "Los retiros requieren una verificación de identidad aprobada.",
    restricted_country: "No disponible para tu país de residencia.",
    wallet_not_ready: "Esta billetera aún no se puede usar: es nueva o no pasó la revisión.",
    balance_frozen: "Tu saldo está congelado. Escribe a soporte.",
  },
  admin: {
    tab: "Saldos",
    lead: "Saldos de los traders, sus movimientos y correcciones. Una corrección necesita que otra persona la apruebe.",
    search: "Correo, nombre o ID de usuario",
    find: "Buscar",
    user: "Trader",
    balance: "Saldo",
    requested: "Esperando aprobación",
    none: "No hay nada aquí.",
    amount: "Monto (+ crédito, − débito)",
    reason: "Motivo (qué pasó, número de solicitud)",
    ask: "Solicitar la corrección",
    asked: "Solicitada. Otra persona la aprueba.",
    credit: "Registrar ahora",
    credited: "Registrado: el saldo está actualizado.",
    approve: "Aprobar",
    reject: "Rechazar",
    rejectReason: "Por qué se rechaza",
    moves: "Movimientos",
    adjustments: "Correcciones",
    by: "solicitada por {name}",
    close: "Cerrar",
    pot: "Bolsa",
    potMoney: "Dinero: se puede retirar",
    potBonus: "Bono: vence en 7 días",
    money: "Dinero",
    bonus: "Bono",
    restricted: { sanctioned: "País sancionado: saldo congelado", us: "Residente de EE. UU.: sin payouts ni retiros" },
    usRefund: {
      title: "Reembolsar a un residente de EE. UU.",
      lead: "Reembolsa cada compra a la bolsa de dinero (también las comisiones; el bono vence), cierra todas las cuentas y retiene toda la bolsa de dinero para enviarla a la billetera. Luego se envía como cualquier retiro.",
      wallet: "Billetera",
      run: "Reembolsar y cerrar cuentas",
      done: "Listo: {amount} retenidos para la billetera.",
      noWallet: "No hay ninguna billetera lista: la persona tiene que agregar una (una dirección nueva espera su plazo).",
    },
    withdrawals: {
      title: "Retiros",
      lead: "Envía manualmente desde la billetera del propietario y luego aprueba con el hash de la transacción. Quien prepara no aprueba.",
      prepare: "Preparar",
      approve: "Enviado: aprobar",
      reject: "Rechazar",
      rejectReason: "Rechazado en la revisión",
      txHash: "Hash de la transacción",
      ownPrepared: "Lo preparaste tú: otra persona lo aprueba",
      net: "neto {amount}",
      none: "No hay retiros.",
    },
    kind: { topup: "Recarga de saldo", fee: "Pago de comisión" },
    status: { requested: "en espera", approved: "aprobada", rejected: "rechazada" },
  },
} satisfies Messages<typeof en>;
